import { useCountries } from "../../context/CountryContext";
import {
  getPhoneCountry,
  sanitizeNationalNumber,
} from "../../utils/phone";

const PhoneInput = ({
  label = "Mobile Number",
  value,
  onChange,
  disabled = false,
  required = false,
  placeholder,
  hint,
  inputStyle,
  selectStyle,
  wrapperStyle,
}) => {
   const { countries, setCountryCode } = useCountries();
   const currentCountry = getPhoneCountry(value?.countryCode, countries);


   return (
     <div style={wrapperStyle}>
       {label ? <label className="form-label">{label}</label> : null}
       <div
         style={{
           display: "grid",
           gridTemplateColumns: "110px 1fr",
           gap: "12px",
         }}
       >
         <select
           value={value?.countryCode || currentCountry.code}
           disabled={disabled}
           required={required}
           onChange={(event) => {
             const newCode = event.target.value;
             setCountryCode(newCode); // Update Global Currency
             onChange({
               countryCode: newCode,
               nationalNumber: value?.nationalNumber || "",
             });
           }}

          style={{
            width: "100%",
            minHeight: "52px",
            borderRadius: "14px",
            border: "1.5px solid #e2e8f0",
            padding: "0 10px",
            fontSize: "14px",
            background: "#f8fafc",
            outline: "none",
            fontWeight: "600",
            color: "#1e293b",
            ...selectStyle,
          }}
        >
          {countries.map((country) => (
            <option key={country.code} value={country.code}>
              {country.code} ({country.dialCode})
            </option>
          ))}

        </select>

        <input
          type="tel"
          required={required}
          disabled={disabled}
          value={value?.nationalNumber || ""}
          onChange={(event) =>
            onChange({
              countryCode: value?.countryCode || currentCountry.code,
              nationalNumber: sanitizeNationalNumber(event.target.value),
            })
          }
          placeholder={placeholder || currentCountry.placeholder}
          style={{
            width: "100%",
            minHeight: "52px",
            borderRadius: "14px",
            border: "1.5px solid #e2e8f0",
            padding: "0 18px",
            fontSize: "15px",
            outline: "none",
            background: "#f8fafc",
            fontWeight: "500",
            ...inputStyle,
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#C5192D";
            e.target.style.background = "#fff";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#e2e8f0";
            e.target.style.background = "#f8fafc";
          }}
        />
      </div>
      {hint ? (
        <p style={{ marginTop: "8px", fontSize: "12px", color: "#6b7280" }}>{hint}</p>
      ) : null}
    </div>
  );
};

export default PhoneInput;
